import { useEffect, useState } from 'react';
import { QueryStatus } from 'src/types';
import { HttpControlOperativo } from '../api/httpControlOperativo';
import { OperacionControlOperativoViewDTO } from '../types/dto';

export const useOperacionControlOperativo = (idOperacion: number) => {
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);
  const [operacion, setOperacion] = useState<OperacionControlOperativoViewDTO>();

  useEffect(() => {
    setStatus(QueryStatus.Loading);

    HttpControlOperativo.get(idOperacion)
      .then(data => {
        setOperacion(data);
        setStatus(QueryStatus.Success);
      })
      .catch(() => setStatus(QueryStatus.Error));
  }, [idOperacion]);

  return { status, operacion };
};